import { render, staticRenderFns } from "./PlaylistCard.component.vue?vue&type=template&id=1b0c84f2&scoped=true&"
import script from "./PlaylistCard.component.vue?vue&type=script&lang=js&"
export * from "./PlaylistCard.component.vue?vue&type=script&lang=js&"
import style0 from "./PlaylistCard.component.vue?vue&type=style&index=0&id=1b0c84f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0c84f2",
  null
  
)

export default component.exports